import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Card, Row, Col, Button, Modal } from "react-bootstrap";
import TabPropertyComponent from "./TabPropertyComponent";
import httpClient from "utility/httpClient.util";
import Swal from "sweetalert2";
import "./styles.scss";
const NewFormModal = ({ show, onHide }) => {
  const location = useLocation();
  const history = useHistory();

  const navigateToAssessment = (id) => {
    const currentPath = location.pathname;
    const newPath = currentPath.endsWith("/form-assessment")
      ? `${currentPath}/${id}`
      : currentPath.replace(
          /(\/form-assessment\/[^/]*|\/form-assessment)$/,
          `/form-assessment/${id}`
        );
    history.push(newPath);
  };

  const onSave = async (saveData) => {
    const body = { ...saveData };

    if (!body?.code && !body?.name) {
      Swal.fire({
        title: "Code or Name cannot be empty.",
        icon: "error",
        confirmButtonColor: "#7367f0",
        confirmButtonText: "ตกลง",
      });
      return;
    }
    const postBody = {
      name: body?.name,
      code: body?.code,
      jsonData: body?.jsonData || {},
      isVisible: body?.isVisible ? 1 : 0,
      isAutoSavePDF: body?.isAutoSavePDF ? 1 : 0,
      isSingleFormPerVn: body?.isSingleFormPerVn ? 1 : 0,
      specialtyCode: body?.specialtyCode,
    };
    try {
      const response = await httpClient.post(
        `/designer/form-assessment`,
        postBody
      );
      if (response.status !== 200) {
        await Swal.fire({
          title: "บันทึกไม่สำเร็จ",
          icon: "error",
          confirmButtonColor: "#7367f0",
          confirmButtonText: "ตกลง",
        });
        return;
      }

      const formAssessmentId = response?.data?.data?.formAssessmentId;

      if (body?.version) {
        const versionBody = {
          formAssessmentId,
          version: body?.version?.version,
          jsonData: body?.data,
          isVisible: body?.isVisible ? 1 : 0,
        };

        await httpClient.post(
          `/designer/form-assessment-revision`,
          versionBody
        );
      }

      if (body?.ehrSyncEnabled) {
        if (!body?.ehrTemplateId) {
          throw new Error("กรุณาระบุ EHR Template ID");
        }
        await httpClient.put(
          `/designer/form-assessment/${formAssessmentId}/ehr-binding`,
          {
            isEnabled: 1,
            templateId: body.ehrTemplateId,
            syncMode: body?.isSingleFormPerVn
              ? "single_per_visit"
              : "per_assessment",
          }
        );
      }

      await Swal.fire({
        title: "บันทึกสำเร็จ",
        icon: "success",
        confirmButtonColor: "#7367f0",
        confirmButtonText: "ตกลง",
      }).then((result) => {
        if (result.isConfirmed) {
          navigateToAssessment(formAssessmentId);
        }
      });
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        "บันทึกไม่สำเร็จ";
      await Swal.fire({
        title: "EHR Validation",
        text:
          typeof errorMessage === "string"
            ? errorMessage
            : JSON.stringify(errorMessage),
        icon: "error",
        confirmButtonColor: "#7367f0",
        confirmButtonText: "ตกลง",
      });
      throw error;
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="new-assessment-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Add New Assessment
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <TabPropertyComponent onSave={onSave} showMinimal={true} />
      </Modal.Body>
    </Modal>
  );
};

export default NewFormModal;
